<div class="container">
  <app-titulo>Relatórios Mensais</app-titulo>
  <app-subtitulo>
    Selecione o mês e ano que deseja ver o relatório.
  </app-subtitulo>
  <form [formGroup]="form" (change)="getCaixasPorData()">
    <app-input
      type="select"
      label="Mês"
      placeholder="Selecione"
      name="NU_MONTH"
      formControlName="NU_MONTH"
      [selectData]="mesOptions"
      [preserveOrder]="true"
      (ngModelChange)="onChangeMes($event)"
      [requiredInput]="true"
    ></app-input>
    <app-input
      type="select"
      label="Ano"
      name="NU_YEAR"
      formControlName="NU_YEAR"
      [selectData]="anoOptions"
      (ngModelChange)="onChangeAno($event)"
      [requiredInput]="true"
    ></app-input>
  </form>
  <div class="tabela">
    <app-tabela-form
      *ngIf="!isLoading && tableData.length"
      [data]="tableData"
      [columns]="tableColumns"
    ></app-tabela-form>
    <h2 *ngIf="!isLoading && !tableData.length">
      Selecione o ano e data que deseja visualizar o relatório
    </h2>
  </div>
  <div class="buttons">
    <app-botao
      text="Cancelar"
      color="#27272A"
      bgColor="#F8FAFC"
      border="1px solid #D1D5DB"
      (click)="onCancelar()"
    />
    <app-botao
      text="Baixar"
      [bgColor]="!form.valid ? '#D1D5DB' : 'var(--primary-color)'"
      border="1px solid #D1D5DB"
      (click)="getRelatorio()"
      [disabled]="!form.valid"
    />
    <app-botao
      text="Imprimir Ticket"
      [bgColor]="!form.valid ? '#D1D5DB' : 'var(--primary-color)'"
      border="1px solid #D1D5DB"
      (click)="getRelatorioTxt()"
      [disabled]="!form.valid"
    />
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
